// src/app/app-initializer.ts
import { PLATFORM_ID, TransferState, inject } from '@angular/core';
import { makeStateKey } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApiService, HOSTEL_HYDRATION_LEVEL } from './services/api/api.service';

// const CONFIG_KEY = makeStateKey<any>('config');
export const SSR_DATA = makeStateKey<any>('ssrData');

/**
 * Pass state from server to client post-ssr
 */
export function appInitializer() {
  const transferState = inject(TransferState);
  const platformId = inject(PLATFORM_ID);
  const apiService = inject(ApiService);

  return () =>
    new Promise<void>((resolve) => {
      if (isPlatformBrowser(platformId)) {
        const preloadedState = (window as any).__TRANSFER_STATE__;

        if (preloadedState) {
          transferState.set(SSR_DATA, preloadedState);

          // todo return device type
          if (preloadedState['HOSTEL']) {
            const propertiesCache = apiService.propertiesCache;
            propertiesCache.set(preloadedState['HOSTEL']._id, {
              data: preloadedState['HOSTEL'],
              hydratedness: HOSTEL_HYDRATION_LEVEL.PARTIAL,
              timestamp: Date.now(),
            });
          }
          delete (window as any).__TRANSFER_STATE__;
        }
      } else {
        console.log('on server, not checking for transfer state');
      }

      resolve();
    });
}

function determineBaseHref(url: string): string {
  // Your logic to determine base href
  if (url.startsWith('/it')) {
    return '/it/';
  }
  if (url.startsWith('/fr')) {
    return '/fr/';
  }
  if (url.startsWith('/de')) {
    return '/de/';
  }
  if (url.startsWith('/es')) {
    return '/es/';
  }
  if (url.startsWith('/pt')) {
    return '/pt/';
  }
  return '/';
}

export function baseHrefFactory(): string {
  const platformId = inject(PLATFORM_ID);
  if (isPlatformBrowser(platformId)) {
    return determineBaseHref(window.location.pathname);
  }

  return '/';
}
